import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Vision from "@/components/Vision";
import Benefits from "@/components/Benefits";
import WhyNow from "@/components/WhyNow";
import ContactForms from "@/components/ContactForms";
import ErrorBoundary from "@/components/ErrorBoundary";
import Footer from "@/components/Footer";

const Index = () => {
  console.log('🟢 Index component rendering');
  
  return (
    <div className="min-h-screen bg-background font-sans">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Vision />
        <Benefits />
        <WhyNow />
        <ErrorBoundary fallback={<div style={{color: 'red', padding: '20px'}}>❌ ContactForms Error!</div>}>
          <ContactForms />
        </ErrorBoundary>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
